import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Dot: React.FC<SVGProps<SVGSVGElement>> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.2" d="M3 12C3 7.02944 7.02944 3 12 3V3C16.9706 3 21 7.02944 21 12V12C21 16.9706 16.9706 21 12 21V21C7.02944 21 3 16.9706 3 12V12Z" fill="#02C8C6" />
      <path d="M6 12C6 8.68629 8.68629 6 12 6V6C15.3137 6 18 8.68629 18 12V12C18 15.3137 15.3137 18 12 18V18C8.68629 18 6 15.3137 6 12V12Z" fill="#02C8C6" />
    </svg>
  )
}

Dot.displayName = 'Dot'

export default withIcon(Dot)
